<div mat-dialog-title>
  <div class="h4 mb-0" [attr.data-testId]="data.title">{{data.title}}</div>
  <button mat-icon-button data-testId="cancel-icon-copy-dpr-data" (click)="onCancel()">
    <mat-icon svgIcon="close"></mat-icon>
  </button>
</div>

<div mat-dialog-content class="noPadding">
  <mat-card class="flex-row align-items-center m-3 p-3">
    <mat-icon class="mr-2 icon--large" color="primary" svgIcon="information"></mat-icon>
    <span data-testId="copy-dpr-data-info" i18n="@@dprDetails.copyFromDprModal.txtSelectSectionsOfPropertiesToCopy">
      Select the sections and the properties to copy.
    </span>
  </mat-card>

  <app-grid [data]="gridData" [columns]="gridColumns" [options]="gridOptions"></app-grid>
</div>

<div mat-dialog-actions class="d-flex">
  <div
    [matTooltip]="staticMessage.UnavailableInOfflineTooltip | staticMessage"
    [matTooltipDisabled]="data.isAppOnline$ | async"
  >
    <button
      mat-flat-button
      color="primary"
      data-testId="copy-dpr-data"
      [disabled]="(data.isAppOnline$ | async) === false"
      (click)="onCopy()"
      cdkFocusInitial
    >
      <mat-icon svgIcon="cloud-download"></mat-icon>
      <span>{{staticMessage.CopyButton | staticMessage}}</span>
    </button>
  </div>
  <button mat-button color="primary" data-testId="cancel-copy-dpr-data" (click)="onCancel()">
    {{staticMessage.CancelButton | staticMessage}}
  </button>
</div>
